<template>
  <div class="account-right">
    <div class="account-breadcrumb">
      <ul class="breadcrumb-innerpage">
        <li>
          <router-link :to="{ name: 'home' }"
            >{{ _T('Home')
            }}<img src="/images/svg/global/arrow-right-r.svg" alt=""
          /></router-link>
        </li>
        <li>{{ _T('Saved Card') }}</li>
      </ul>
    </div>
    <div class="account-card group-tab">
      <div class="account-header save-header">
        <Loader v-show="processInProgress(process)" status="DELETING" />
        <h4 class="d-flex">
          <router-link :to="{ name: 'profile' }" class="d-sm-none d-block mr-2">
            <img src="/images/svg/global/left-arrow.svg" alt="" />
          </router-link>
          {{ _T('Saved Card') }}
        </h4>
      </div>
      <div class="account-body saved-card-body">
        <div class="media">
          <div class="icon-saved">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0008 0.601562C7.993 0.601562 4.72852 3.86604 4.72852 7.8738C4.72852 8.44942 4.8007 9.02599 4.94414 9.60161C5.13633 10.5372 5.49633 11.1138 5.97633 11.9294C6.09633 12.1216 6.21633 12.3138 6.33633 12.5294C6.48071 12.7938 6.64853 13.0338 6.79195 13.2738C7.43976 14.3294 7.82414 14.9538 7.82414 16.2016V19.2016C7.82414 19.9694 8.37633 20.5938 9.09633 20.7372C9.40852 22.3694 10.3685 23.4017 12.0241 23.4017C13.6797 23.4017 14.6396 22.3695 14.9519 20.7372C15.6719 20.6172 16.224 19.9694 16.224 19.2016V16.2016C16.224 14.9538 16.6084 14.3294 17.2562 13.2738C17.4006 13.0338 17.544 12.7938 17.7119 12.5294C17.8319 12.3138 17.9519 12.0972 18.0719 11.9294C18.5519 11.1138 18.9119 10.5372 19.104 9.62503C19.2484 9.04942 19.3197 8.44942 19.3197 7.87284C19.2728 3.86604 16.0084 0.601562 12.0006 0.601562H12.0008ZM14.9285 16.946H9.073V16.2017C9.073 16.0573 9.073 15.9139 9.04862 15.7938H14.9286C14.9286 15.9382 14.9042 16.0582 14.9042 16.2017L14.9052 16.946H14.9285ZM14.6651 19.4896H9.33731C9.19293 19.4896 9.07292 19.3696 9.07292 19.2252V18.2408H14.9284V19.2252C14.9284 19.3696 14.8084 19.4896 14.665 19.4896H14.6651ZM12.0006 22.106C11.665 22.106 10.7284 22.106 10.3928 20.7617H13.6328C13.2728 22.106 12.3362 22.106 12.0006 22.106ZM17.8083 9.33732C17.664 10.0573 17.3762 10.5129 16.944 11.2817C16.824 11.4739 16.704 11.6661 16.584 11.9061C16.4396 12.1705 16.2962 12.4105 16.1518 12.6261C15.7674 13.2739 15.4074 13.8505 15.1918 14.5217H8.83177C8.61615 13.8495 8.27958 13.2739 7.87177 12.6261C7.7274 12.4105 7.58396 12.1705 7.43958 11.9061C7.31958 11.6661 7.1752 11.4739 7.07958 11.2817C6.62396 10.5373 6.35958 10.0573 6.19177 9.33732C6.07177 8.85732 5.99958 8.37732 5.99958 7.89732C5.99958 4.58508 8.68734 1.89732 11.9996 1.89732C15.3118 1.89732 17.9996 4.58508 17.9996 7.89732C18.0005 8.35387 17.9283 8.83387 17.8083 9.33732H17.8083Z"
              ></path>
              <path
                d="M11.3287 3.50629C9.52874 3.77068 8.06426 5.21068 7.80098 7.01077C7.75317 7.37077 7.99317 7.68296 8.35317 7.73077H8.4488C8.76099 7.73077 9.02441 7.49077 9.07318 7.17858C9.26537 5.93077 10.2488 4.92296 11.4977 4.7541C11.8577 4.70629 12.0977 4.36972 12.0499 4.0341C12.0255 3.69755 11.6889 3.45755 11.3289 3.50629H11.3287Z"
              ></path>
            </svg>
          </div>
          <div class="media-body">
            <h5>{{ _T('Cards') }}</h5>
            <h4>
              {{ _T('Your saved cards will show up here') }}
            </h4>
          </div>
        </div>
        <div class="your-card">
          <h6 v-if="customer_credit_cards.length">
            {{ _T('Your Cards') }}
            <span>({{ customer_credit_cards.length }})</span>
          </h6>
          <div class="row">
            <template v-if="customer_credit_cards.length">
              <div
                class="col-lg-6 col-md-6 col-sm-12 pb-2"
                v-for="(card, key) in customer_credit_cards"
                :key="key"
              >
                <div class="card-details">
                  <img
                    :src="'/images/checkout/' + card_image(card.card_type)"
                    alt=""
                  />
                  <a
                    href="#"
                    class="delete-icon d-sm-none d-block"
                    data-toggle="modal"
                    data-target="#delete-card"
                  >
                    <img src="/images/svg/global/trash-w.svg" alt="" />
                  </a>
                  <div class="content-number">
                    <label>{{ _T('Card Number') }}</label>
                    <h3>XXXX - XXXX - XXXX - {{ card.card_last4 }}</h3>
                  </div>
                  <div class="d-flex">
                    <div class="content-number">
                      <label>{{ _T('Card Holder') }}</label>
                      <h6>{{ card.customer_name || web_user.name }}</h6>
                    </div>
                    <!-- <div class="content-number">
                    <label>{{ _T('Expires') }}</label>
                    <h6>{{ _T('09/20') }}</h6>
                  </div> -->
                  </div>
                  <div class="card-hover">
                    <button
                      type="button"
                      class="btn btn-solid"
                      @click.prevent="deleteCard(card._id.$oid)"
                    >
                      {{ _T('Remove Cards') }}
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <h5 v-else class="p-2 nothing-found">
              {{ _T('No Saved Cards found') }}
            </h5>
          </div>
        </div>
      </div>
    </div>
    <!-- <card-model></card-model> -->
  </div>
</template>

<script>
// import CardModel from '@/components/Blocks/Payment/CardModel'
import Loader from '@/components/Elements/Loader'
import { mapGetters } from 'vuex'
export default {
  name: 'SavedCards',
  components: {
    // CardModel,
    Loader,
  },
  data () {
    return {
      process: 'delete-card',
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      'customer_credit_cards',
      'processInProgress',
      'web_user',
    ]),
  },
  methods: {
    card_image (type) {
      let img = 'mastercard.png'

      switch (type) {
        case 'VISA':
          img = 'visa.png'
          break
      }
      return img
    },
    deleteCard (cardId) {
      this.$store.dispatch('startProcess', {
        process: this.process,
        progress: true,
      })
      this.$store
        .dispatch('deleteSimplifyCard', cardId)
        .then(() => {
          this.$store.dispatch('load_customer', true)
          this.$store.dispatch('showNotification', {
            text: this._T('Card deleted successfully'),
            status: 'success',
          })
        })
        .catch(error => {
          this.$store.dispatch('showNotification', {
            text: this._T(error),
            status: 'error',
          })
        })
        .finally(() => {
          this.$store.dispatch('stopProcess', this.process)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .account-menu {
    .account-breadcrumb {
      ul {
        padding-left: unset;
        padding-right: 0;
        text-align: right;
      }
    }
  }
}
.account-card.group-tab {
  .account-header {
    padding: $px18 $px30;
    border-bottom: $px1 solid $dark-border;
    h4 {
      font-weight: 600;
      margin-bottom: 0;
    }
  }
  .saved-card-body {
    padding: $px30;
    overflow: hidden;
    max-height: $px500;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .nothing-found {
      font-weight: bold;
    }

    .media {
      padding: $px20;
      border: $px1 solid $light-border;
      border-radius: $px4;
      margin-bottom: $px30;

      .icon-saved {
        width: $px44;
        height: $px44;
        border-radius: 100%;
        background-color: rgba(var(--color-warning-color-source), 0.1);
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          width: $px24;
          height: $px24;

          path {
            fill: $warning-color;
          }
        }
      }

      .media-body {
        padding-left: $px20;

        h5 {
          letter-spacing: 0.005em;
        }

        h4 {
          margin-bottom: 0;
          font-weight: 600;
          color: $black;
        }
      }
    }

    .your-card {
      padding-top: $px24;
      border-top: $px1 solid $light-border;

      > h6 {
        margin-bottom: $px24;
      }

      h6 {
        font-weight: 600;
        line-height: $px22;
        letter-spacing: 0.005em;
      }

      .card-details {
        position: relative;
        overflow: hidden;
        background: linear-gradient(
          123.69deg,
          $tertiary-color 0%,
          $tertiary-light 100%
        );
        border-radius: $px4;
        padding: $px15;

        .content-number {
          color: $white;
          padding-top: $px32;

          label {
            font-weight: 600;
            font-size: $px10;
            line-height: $px11;
            letter-spacing: 0.5px;
            color: $light-border;
            opacity: 0.5;
            text-transform: uppercase;
            margin-bottom: 0;
          }

          h3 {
            font-size: $px22;
            margin-bottom: 0;
            line-height: $px27;
            letter-spacing: 0.02em;
          }

          h6 {
            font-weight: normal;
            line-height: $px22;
            letter-spacing: 0.5px;
            margin-bottom: 0;
          }
        }

        .d-flex {
          padding-top: $px20;
          justify-content: space-between;

          .content-number {
            padding-top: 0;
          }
        }

        &:hover {
          .card-hover {
            opacity: 1;
            border-radius: 0%;
            transform: scale(1);
            transition: all 0.3s ease;
          }
        }

        .card-hover {
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(var(--color-font-color-source), 0.8);
          opacity: 0;
          border-radius: 100%;
          transform: scale(0);
          transition: all 0.3s ease;
        }
      }

      .new-card {
        border: $px1 solid $light-border;
        border-radius: $px4;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .plus-icon {
          width: $px40;
          height: $px40;
          background-color: $color-primary;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          margin: 0 auto;
        }

        h6 {
          margin-bottom: 0;
          margin-top: $px10;
        }
      }
    }
  }
}
.account-breadcrumb {
  ul {
    li {
      line-height: $px17;
      letter-spacing: 0.005em;
      a {
        font-weight: 600;
      }
      img {
        margin-left: $px12;
        margin-right: $px7;
      }
    }
  }
  .breadcrumb-innerpage {
    li {
      font-weight: 600;
    }
  }
}
.account-menu {
  padding-top: $px40;
  .menu-left {
    margin-bottom: $px90;
    .menu-title {
      h4 {
        margin-bottom: calc(
          #{$px30} + (68 - 30) * ((100vw - #{$px320}) / (1920 - 320))
        );
        font-size: calc(
          #{$px16} + (20 - 16) * ((100vw - #{$px320}) / (1920 - 320))
        );
        line-height: $px24;
        color: $font-color;
        font-weight: 600;
        span {
          display: none;
        }
      }
    }
    ul {
      li {
        display: block;
        &.active {
          a {
            svg {
              path {
                fill: $primary-color !important;
              }
            }
            h4 {
              color: $primary-color;
            }
          }
        }
        a {
          svg {
            vertical-align: bottom;
          }
          h4 {
            display: inline-block;
            margin-bottom: 0;
            padding-left: $px6;
            color: $font-color;
            position: relative;
            .dot-notify {
              width: $px6;
              height: $px6;
              background-color: $primary-color;
              border-radius: 100%;
              position: absolute;
              top: 0;
              right: -$px12;
            }
          }
        }
        + li {
          margin-top: calc(
            #{$px20} + (48 - 20) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
      }
    }
  }
  .account-right {
    .account-breadcrumb {
      ul {
        li {
          line-height: $px17;
          letter-spacing: 0.005em;
          a {
            font-weight: 600;
          }
          img {
            margin-left: $px12;
            margin-right: $px7;
          }
        }
      }
      .breadcrumb-innerpage {
        li {
          font-weight: 600;
        }
      }
    }
    .account-card {
      box-shadow: 0px $px4 $px34 rgba($black, 0.07);
      margin: $px18 0 $px30;
      border-radius: $px10;
      .account-body {
        &.profile-media {
          .media {
            padding: calc(
                #{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))
              )
              calc(#{$px20} + (45 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
            align-items: center;
            .btn {
              padding: $px8
                calc(
                  #{$px20} + (48 - 20) * ((100vw - #{$px320}) / (1920 - 320))
                );
            }
            + .media {
              border-top: $px1 solid $light-border;
            }
            .profile-user {
              img {
                width: $px40;
                height: $px40;
                border-radius: 100%;
              }
            }
            .media-body {
              margin-left: $px20;
              h6 {
                margin-bottom: $px5;
                line-height: $px14;
                letter-spacing: 0.005em;
                color: rgba(var(--color-font-color-source), 0.44);
                font-weight: 500;
              }
              h4 {
                margin-bottom: 0;
                line-height: $px18;
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1366px) {
  .saved-card-body {
    .your-card {
      .col-lg-5 {
        flex: 0 0 45%;
        max-width: 45%;
      }
    }
  }
}
@media (max-width: 1199px) {
  .saved-card-body {
    .your-card {
      .col-lg-5 {
        flex: 0 0 54%;
        max-width: 54%;
      }
    }
  }
}
@media (max-width: 991px) {
  .saved-card-body {
    height: auto;
    padding: $px20 !important;
    .media {
      margin-bottom: $px20;
    }
    .wallet-box {
      .btn {
        width: auto;
      }
    }
    .your-card {
      padding-top: $px14;
      > h6 {
        margin-bottom: $px14;
      }
      .col-lg-5 {
        flex: 0 0 100%;
        max-width: 100%;
      }
      .card-details {
        .card-hover {
          .btn {
            padding: $px8 $px12;
          }
        }
      }
      .new-card {
        padding: $px30 0;
        margin-top: $px20;
        height: auto;
        .plus-icon {
          transform: scale(0.8);
        }
        h6 {
          margin-top: 0;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .saved-card-body {
    .media {
      display: none;
    }
    .your-card {
      padding-top: 0 !important;
      border-top: none !important ;
      .new-card {
        padding: $px12 0;
        border-style: dashed;
        .plus-icon {
          display: inline-block;
          width: auto;
          height: auto;
          background-color: $transparent;
          svg {
            vertical-align: text-top;
            path {
              fill: $primary-color !important;
            }
          }
        }
        h6 {
          display: inline-block;
          cursor: pointer;
        }
      }
      .card-details {
        .delete-icon {
          position: absolute;
          right: $px15;
          top: $px15;
          z-index: 1;
        }
        &:hover {
          .card-hover {
            opacity: 0;
          }
        }
      }
      > h6 {
        line-height: $px19;
        span {
          font-weight: normal;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.005em;
          color: $light-font;
        }
      }
    }
  }
  .account-card {
    &.group-tab {
      margin: 0 !important;
      .account-header {
        padding: $px14 $px20;
      }
    }
  }
  .orders-going,
  .saved-card {
    .account-menu {
      padding-top: 0;
      > div {
        padding: 0;
      }
      .account-right {
        .account-card {
          margin-top: 0;
          box-shadow: none;
          border-radius: 0;
        }
      }
    }
    .menu-left {
      display: none;
    }
  }
  .account-right {
    .account-breadcrumb {
      display: none;
    }
  }
}
@media (max-width: 360px) {
  .saved-card-body {
    .your-card {
      .card-details {
        .content-number {
          h3 {
            font-size: $px18;
          }
        }
      }
    }
  }
}
</style>
